export default __webpack_public_path__ + "static/media/selenium.6575c6de.png";